package waldo.sankan.lineamunicipalkmp.web.screens

import waldo.sankan.lineamunicipalkmp.model.*
import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlinx.browser.window
import kotlin.js.Date

@Composable
fun NoticiasScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    
    // Verificamos si la comuna tiene habilitado el servicio de noticias
    // El Admin General siempre tiene acceso
    val esAdminGeneral = uiState.rolAdmin?.rol == "GENERAL"
    // 🛡️ REPARACIÓN DE IDENTIDAD: Buscamos la comuna comparando solo el ID final (sin prefijos)
    val miComuna = uiState.comunas.find { 
        val idLimpio = it.id.split("/").last()
        val refAdminLimpia = uiState.rolAdmin?.comunaAsignadaRef?.split("/")?.last() ?: ""
        idLimpio == refAdminLimpia
    }
    val servicioHabilitado = esAdminGeneral || (miComuna?.noticiasHabilitadas == true)

    var titulo by remember { mutableStateOf("") }
    var contenido by remember { mutableStateOf("") }
    var imagenUrl by remember { mutableStateOf("") }
    
    // Estados para segmentación
    var comunaSeleccionadaRef by remember { mutableStateOf<String?>(null) }
    var comunaSeleccionadaNombre by remember { mutableStateOf<String?>(null) }
    var sectorSeleccionadoRef by remember { mutableStateOf<String?>(null) }
    var sectorSeleccionadoNombre by remember { mutableStateOf<String?>(null) }
    var edadMinima by remember { mutableStateOf("") }
    var edadMaxima by remember { mutableStateOf("") }

    Div({
        style {
            padding(24.px)
            backgroundColor(Color("#1976D2")) // --- 🔵 AZUL INSTITUCIONAL PARA COHERENCIA ---
            minHeight(100.vh)
        }
    }) {
        Div({
            style {
                backgroundColor(Color.white)
                padding(24.px)
                borderRadius(12.px)
                maxWidth(1000.px)
                property("margin", "0 auto")
                property("box-shadow", "0 10px 25px rgba(0,0,0,0.2)") // Sombra profunda para despegar del azul
            }
        }) {
            // Cabecera
            Div({
                style {
                    display(DisplayStyle.Flex)
                    justifyContent(JustifyContent.SpaceBetween)
                    alignItems(AlignItems.Center)
                    marginBottom(24.px)
                    property("border-bottom", "2px solid #1976D2")
                    paddingBottom(16.px)
                }
            }) {
                H2({ style { margin(0.px); color(Color("#1976D2")) } }) { Text("Centro de Comunicación Masiva") }
                Button(attrs = {
                    onClick { onBack() }
                    style {
                        padding(8.px, 16.px)
                        backgroundColor(Color("#6c757d"))
                        color(Color.white)
                        border(0.px)
                        borderRadius(6.px)
                        cursor("pointer")
                        fontWeight("bold")
                    }
                }) { Text("Cerrar") }
            }

            // Formulario y Listado
            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Row)
                    gap(30.px)
                    property("flex-wrap", "wrap")
                }
            }) {
                // Columna Izquierda: Redacción
                Div({ style { flex(1); minWidth(400.px) } }) {
                    H3({ style { marginBottom(16.px); color(Color("#333")) } }) { Text("Redactar Nuevo Comunicado") }
                    
                    if (!servicioHabilitado) {
                        Div({
                            style {
                                backgroundColor(Color("#FFF3CD"))
                                padding(24.px)
                                borderRadius(8.px)
                                border(1.px, LineStyle.Solid, Color("#FFEEBA"))
                                color(Color("#856404"))
                                textAlign("center")
                            }
                        }) {
                            H4 { Text("🔔 Servicio No Contratado") }
                            P { Text("El módulo de mensajería masiva no está habilitado para su comuna. Por favor, contacte con el soporte técnico de LineaMuni para activar este servicio.") }
                        }
                    } else {
                        Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px) } }) {
                            // SELECTOR DE COMUNA PARA ADMIN GENERAL
                            if (esAdminGeneral) {
                                Div {
                                    Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Comuna Objetivo") }
                                    Select(attrs = {
                                        style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#1976D2")); fontWeight("bold") }
                                        onChange { event ->
                                            val value = event.value
                                            if (value == "TODAS") {
                                                comunaSeleccionadaRef = null
                                                comunaSeleccionadaNombre = null
                                                viewModel.onComunaNoticiaChanged(null)
                                            } else {
                                                val com = uiState.comunas.find { "comunas/${it.id}" == value }
                                                comunaSeleccionadaRef = "comunas/${com?.id}"
                                                comunaSeleccionadaNombre = com?.comunaDisplayName
                                                viewModel.onComunaNoticiaChanged(comunaSeleccionadaRef)
                                            }
                                            sectorSeleccionadoRef = null
                                            sectorSeleccionadoNombre = null
                                        }
                                    }) {
                                        Option("TODAS", attrs = { if (comunaSeleccionadaRef == null) selected() }) { Text("GLOBAL (Todas las comunas)") }
                                        uiState.comunas.filter { it.estaActiva }.forEach { comuna ->
                                            Option("comunas/${comuna.id}", attrs = { if (comunaSeleccionadaRef == "comunas/${comuna.id}") selected() }) {
                                                Text(comuna.comunaDisplayName)
                                            }
                                        }
                                    }
                                }
                            }

                            // INDICADOR DE CUOTA
                            if (miComuna != null && !esAdminGeneral) {
                                val remanente = (miComuna.noticiasMensualesLimite - miComuna.noticiasMensualesEnviadas).coerceAtLeast(0)
                                Div({
                                    style {
                                        padding(10.px)
                                        backgroundColor(if (remanente > 0) Color("#E3F2FD") else Color("#FFEBEE"))
                                        borderRadius(6.px)
                                        display(DisplayStyle.Flex)
                                        justifyContent(JustifyContent.SpaceBetween)
                                        alignItems(AlignItems.Center)
                                    }
                                }) {
                                    Span({ style { fontWeight("bold"); color(if (remanente > 0) Color("#1976D2") else Color("#D32F2F")) } }) {
                                        Text("Mensajes disponibles este mes: $remanente / ${miComuna.noticiasMensualesLimite}")
                                    }
                                    if (remanente == 0) {
                                        Span({ style { fontSize(12.px); color(Color("#D32F2F")); fontStyle("italic") } }) {
                                            Text("Límite alcanzado")
                                        }
                                    }
                                }
                            }

                            Div {
                                Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Título") }
                                Input(type = InputType.Text) {
                                    value(titulo)
                                    onInput { titulo = it.value }
                                    placeholder("Ej: Alerta Climática")
                                    style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#CCC")) }
                                }
                            }

                            // --- NUEVO: SELECTOR DE ÁNIMO (CATEGORÍA) ---
                            var categoriaSeleccionada by remember { mutableStateOf("GENERAL") }
                            Div {
                                Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Categoría / Ánimo") }
                                Select(attrs = {
                                    style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#1976D2")); fontWeight("bold") }
                                    onChange { event -> categoriaSeleccionada = event.value ?: "GENERAL" }
                                }) {
                                    Option("GENERAL") { Text("📢 NOTICIA DEL DÍA (Naranja)") }
                                    Option("ALERTA") { Text("🚨 AVISO URGENTE (Rojo)") }
                                    Option("EVENTO") { Text("🗓️ PANORAMA / CULTURA (Morado)") }
                                    Option("SEGURIDAD") { Text("🛡️ TU BARRIO SEGURO (Azul)") }
                                    Option("GESTION") { Text("🏗️ OBRAS PARA TI (Verde)") }
                                }
                            }

                            // --- NUEVO: SELECTOR DE IMAGEN DESDE LA GALERÍA ---
                            var imagenSeleccionada by remember { mutableStateOf<org.w3c.files.File?>(null) }
                            Div {
                                Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Imagen de la Noticia (Opcional)") }
                                Input(type = InputType.File) {
                                    onChange { event ->
                                        val file = event.target.files?.item(0)
                                        imagenSeleccionada = file
                                    }
                                    style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#CCC")) }
                                }
                                if (imagenSeleccionada != null) {
                                    Span({ style { fontSize(11.px); color(Color("#388E3C")); fontWeight("bold") } }) {
                                        Text("📎 Archivo listo: ${imagenSeleccionada?.name}")
                                    }
                                }
                            }

                            Div {
                                Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Mensaje") }
                                TextArea {
                                    value(contenido)
                                    onInput { contenido = it.value }
                                    rows(5)
                                    style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#CCC")); property("resize", "none") }
                                }
                            }

                            Div {
                                Label(attrs = { style { display(DisplayStyle.Block); marginBottom(4.px); fontWeight("bold") } }) { Text("Sector (Opcional)") }
                                Select(attrs = {
                                    style { width(100.percent); padding(10.px); borderRadius(6.px); border(1.px, LineStyle.Solid, Color("#CCC")) }
                                    onChange { event ->
                                        val value = event.value
                                        if (value == "TODOS") {
                                            sectorSeleccionadoRef = null
                                            sectorSeleccionadoNombre = null
                                        } else {
                                            val sector = uiState.sectoresComuna.find { it.id == value }
                                            sectorSeleccionadoRef = sector?.id
                                            sectorSeleccionadoNombre = sector?.nombre
                                        }
                                    }
                                }) {
                                    Option("TODOS", attrs = { if (sectorSeleccionadoRef == null) selected() }) { Text("Toda la Comuna") }
                                    uiState.sectoresComuna.forEach { sector ->
                                        Option(sector.id, attrs = { if (sectorSeleccionadoRef == sector.id) selected() }) { Text(sector.nombre) }
                                    }
                                }
                            }

                            val remanenteCalculado = miComuna?.let { it.noticiasMensualesLimite - it.noticiasMensualesEnviadas } ?: 1

                            Button(attrs = {
                                onClick {
                                    if (titulo.isNotBlank() && contenido.isNotBlank()) {
                                        viewModel.enviarNoticiaMasiva(
                                            titulo = titulo,
                                            contenido = contenido,
                                            fotoArchivo = imagenSeleccionada, // Pasamos el archivo real
                                            categoria = categoriaSeleccionada,
                                            sectorRef = sectorSeleccionadoRef,
                                            sectorNombre = sectorSeleccionadoNombre,
                                            edadMin = edadMinima.toIntOrNull(),
                                            edadMax = edadMaxima.toIntOrNull(),
                                            overrideComunaRef = comunaSeleccionadaRef,
                                            overrideComunaNombre = comunaSeleccionadaNombre
                                        )
                                        titulo = ""; contenido = ""; imagenSeleccionada = null; categoriaSeleccionada = "GENERAL"
                                    } else {
                                        window.alert("Complete título y contenido.")
                                    }
                                }
                                if (uiState.isLoadingGlobal || (!esAdminGeneral && remanenteCalculado <= 0)) disabled()
                                style {
                                    padding(12.px); backgroundColor(if (uiState.isLoadingGlobal || (!esAdminGeneral && remanenteCalculado <= 0)) Color.gray else Color("#1976D2"))
                                    color(Color.white); fontWeight("bold"); border(0.px); borderRadius(8.px); cursor(if (uiState.isLoadingGlobal || (!esAdminGeneral && remanenteCalculado <= 0)) "not-allowed" else "pointer")
                                }
                            }) {
                                val botonTexto = when {
                                    uiState.isLoadingGlobal -> "ENVIANDO..."
                                    !esAdminGeneral && remanenteCalculado <= 0 -> "LIMITE MENSUAL AGOTADO"
                                    else -> "📢 ENVIAR COMUNICADO"
                                }
                                Text(botonTexto)
                            }
                        }
                    }
                }

                // Columna Derecha: Historial
                Div({ style { flex(1); minWidth(350.px); property("border-left", "1px solid #EEE"); paddingLeft(20.px) } }) {
                    H3({ style { marginBottom(16.px); color(Color("#333")) } }) { Text("Historial") }
                    
                    Div({
                        style {
                            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(12.px)
                            maxHeight(600.px); property("overflow-y", "auto"); paddingRight(8.px)
                        }
                    }) {
                        if (uiState.historialNoticias.isEmpty()) {
                            P({ style { color(Color.gray); fontStyle("italic") } }) { Text("No hay comunicados.") }
                        } else {
                            uiState.historialNoticias.forEach { noticia ->
                                Div({
                                    style {
                                        padding(12.px); backgroundColor(Color("#F1F3F5"))
                                        borderRadius(8.px); property("border-left", "4px solid #1976D2")
                                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(4.px)
                                    }
                                }) {
                                    Div({ style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center) } }) {
                                        B { Text(noticia.titulo) }
                                        Div({ style { display(DisplayStyle.Flex); gap(8.px); alignItems(AlignItems.Center) } }) {
                                            Span({ style { fontSize(11.px); color(Color.gray) } }) { 
                                                Text(formatTimestamp(noticia.fechaCreacion)) 
                                            }
                                            if (esAdminGeneral) {
                                                Button(attrs = {
                                                    onClick { viewModel.onEliminarNoticia(noticia.id) }
                                                    style {
                                                        backgroundColor(Color("#dc3545")); color(Color.white)
                                                        border(0.px); borderRadius(4.px); padding(2.px, 6.px)
                                                        cursor("pointer"); fontSize(10.px)
                                                    }
                                                    title("Eliminar comunicado")
                                                }) { Text("🗑") }
                                            }
                                        }
                                    }
                                    P({ style { fontSize(13.px); margin(4.px, 0.px) } }) { Text(noticia.contenido) }
                                    if (noticia.comunaNombre != null) {
                                        Span({ style { fontSize(10.px); color(Color("#1976D2")); fontWeight("bold") } }) {
                                            Text("Destino: ${noticia.comunaNombre}")
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

fun formatTimestamp(timestamp: Any?): String {
    val longTime = when (timestamp) {
        is Long -> timestamp
        is Double -> timestamp.toLong()
        is String -> timestamp.toLongOrNull()
        else -> null
    } ?: return "N/A"

    val date = Date(longTime)
    val dia = date.getDate().toString().padStart(2, '0')
    val mes = (date.getMonth() + 1).toString().padStart(2, '0')
    val anio = date.getFullYear()
    return "$dia/$mes/$anio"
}
